import { Globe, MapPin, Star, Zap } from "lucide-react";

const VALUE_POINTS = [
  {
    icon: Globe,
    title: "Websites Built to Convert",
    detail: "Mobile-friendly sites designed around enquiries.",
  },
  {
    icon: MapPin,
    title: "Stronger Google Visibility",
    detail: "Show up where locals search for your services.",
  },
  {
    icon: Star,
    title: "More Genuine Reviews",
    detail: "Make it easy for happy customers to review you.",
  },
  {
    icon: Zap,
    title: "Faster Lead Follow-Up",
    detail: "Reply to new enquiries before they go cold.",
  },
];

export function ProofBand() {
  return (
    <section
      aria-label="What FullScale Marketing focuses on"
      className="section-dark border-y border-white/10"
    >
      <div className="container-wide py-12 sm:py-14 lg:py-16">
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-7 lg:gap-8">
          {VALUE_POINTS.map((point) => (
            <li key={point.title} className="flex items-start gap-3.5">
              <span className="mt-0.5 flex-shrink-0 w-10 h-10 rounded-xl bg-primary/15 flex items-center justify-center">
                <point.icon className="w-5 h-5 text-primary" strokeWidth={1.75} />
              </span>
              <div className="min-w-0">
                <p className="text-base font-semibold leading-snug text-foreground-dark">
                  {point.title}
                </p>
                <p className="text-base leading-[1.6] text-foreground-dark/70 mt-1.5">
                  {point.detail}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
